<template>
    <a :href="href">
        <slot />
    </a>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            to: {
                type: Object,
                required: true
            }
        },
        computed: {
            href () {
                if (_.has(this.to, 'name')) {
                    return this.$laroute.route(this.to.name, this.to.params)
                } else if (_.has(this.to, 'path')) {
                    return this.to.path
                } else {
                    return this.to
                }
            }
        }
    }
</script>
